import { render } from "./TravelingByRadio.vue?vue&type=template&id=740176f5"
import script from "./TravelingByRadio.vue?vue&type=script&lang=js"
export * from "./TravelingByRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__